export const availableRoles = {
    "Doer": ['Doer'],
    "Knight": ['Doer', 'Knight'],
    "Baron": ['Doer', 'Knight', 'Baron'],
    "King": ['Doer', 'Knight', 'Baron', 'King', 'Admin'],
    "Admin": ['Doer', 'Knight', 'Baron', 'King', 'Admin']
}